/* ============================================================
   Flipper Kids - Native SKU Search (v8)
   Author: Claude Fable 5 (Anthropic AI) | Created: 2026-07-04
   History: v2 merged handlers+fixed syntax; v3 suggest.json (417); v4-v6
     custom dropdown (corner popup + page jump, dropped); v7 taught the
     Boost native live search to match SKUs via an element-level value
     getter override on input[name="q"] - the live dropdown works, BUT
     pressing Enter did not navigate to SKU results.
   v8 2026-07-05: keep v7's getter (live box works) AND explicitly handle
     form submit / Enter: on a numeric query we cancel the native submit
     and navigate to /search?type=product&q=variants.sku:<n>* OR title:<n>*
     ourselves, so the full results page also matches SKUs. Verified the
     target URL returns the SKU product server-side.
   ------------------------------------------------------------
   AI-CONTEXT (for any AI/developer reading this later):
   Two paths must feed the SKU field-query:
   1. LIVE BOX: Boost reads input.val()/serialize() (= input.value). The
      element-level value getter below returns
      "variants.sku:<n>* OR title:<n>*" whenever the typed text is numeric
      (2+ digits), so the native live results box matches SKUs. Visible text
      stays the digits (we only ever write via the native setter).
   2. ENTER / SUBMIT: some code paths read the raw field value or the theme
      intercepts submit, so Enter didn't carry the field-query. We now add a
      capture-phase submit + keydown(Enter) handler: for a numeric query we
      preventDefault + navigate to the /search field-query URL directly.
   Non-numeric text queries are untouched in both paths.
   RESULTS PAGE COSMETIC: on /search we set the visible input back to the
   plain number via the native setter.
   FILES: this file + one script tag in layout/theme.liquid. (Old
   templates/search.sku-json.liquid is unused now; harmless.) Revert by
   deleting this file + that script tag.
   ============================================================ */
(function () {
  var NUM_RE = /^\d{2,}$/;
  function fieldQuery(n) { return 'variants.sku:' + n + '* OR title:' + n + '*'; }

  var nativeDesc = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
  function nativeGet(input) { return nativeDesc.get.call(input); }
  function nativeSet(input, v) { nativeDesc.set.call(input, v); }

  /* plain typed number for an input, or '' if not a numeric query */
  function plainNumber(input) {
    var t = (nativeGet(input) || '').trim();
    return NUM_RE.test(t) ? t : '';
  }

  function redirect(n) {
    window.location.href = '/search?type=product&q=' + encodeURIComponent(fieldQuery(n));
  }

  /* ---- 1) live box: value getter returns SKU field-query for numeric text ---- */
  function hookInput(input) {
    if (input.__fkHooked) return;
    input.__fkHooked = true;
    Object.defineProperty(input, 'value', {
      configurable: true,
      get: function () {
        var real = nativeDesc.get.call(this);
        var t = (real || '').trim();
        return NUM_RE.test(t) ? fieldQuery(t) : real;
      },
      set: function (v) { nativeDesc.set.call(this, v); }
    });
  }
  function hookAll() { document.querySelectorAll('input[name="q"]').forEach(hookInput); }
  hookAll();
  document.addEventListener('DOMContentLoaded', hookAll);
  new MutationObserver(hookAll).observe(document.documentElement, { childList: true, subtree: true });

  /* ---- 2) Enter / submit: navigate to the SKU results URL ourselves ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if ((form.getAttribute('action') || '').indexOf('/search') === -1) return;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    var n = plainNumber(input);
    if (!n) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    redirect(n);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.keyCode !== 13) return;
    var t = e.target;
    if (!(t instanceof HTMLInputElement) || t.name !== 'q') return;
    var n = plainNumber(t);
    if (!n) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    redirect(n);
  }, true);

  /* ---- results page cosmetic: show the plain number ---- */
  document.addEventListener('DOMContentLoaded', function () {
    if (window.location.pathname.indexOf('/search') === -1) return;
    var params = new URLSearchParams(window.location.search);
    var q = params.get('q') || '';
    var m = q.match(/^variants\.sku:(\d{2,})\* OR title:\1\*$/);
    if (!m) return;
    document.querySelectorAll('input[name="q"]').forEach(function (el) { nativeSet(el, m[1]); });
  });
})();
